import { Component, EventEmitter, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { MessageTemplatesService, MessageTemplate } from 'src/app/core/services/message-templates.service';
import { ApplicationContextService } from 'src/app/core/services/application-context.service';import Swal from 'sweetalert2';
import { MessageTemplateModalComponent } from '../message-template-modal/message-template-modal.component';

@Component({
  selector: 'app-saved-replies-modal',
  templateUrl: './saved-replies-modal.component.html',
  styleUrls: ['./saved-replies-modal.component.scss']
})
export class SavedRepliesModalComponent implements OnInit {
  templates: MessageTemplate[] = [];
  searchTerm: string = '';
  isLoading: boolean = false;
  currentUserId: string = '';
  currentPage: number = 1;
  pageSize: number = 10;
  useTemplate = new EventEmitter<MessageTemplate>();

  constructor(
    public bsModalRef: BsModalRef,
    private readonly _messageTemplatesService: MessageTemplatesService,
    private readonly _appContextService: ApplicationContextService,
    private readonly _modalService: BsModalService) {}

  ngOnInit(): void {
    const state = (this.bsModalRef as any).initialState ?? {};
    this.currentUserId = state.currentUserId || (this as any).currentUserId || '';
    if (this.currentUserId) {
      this.loadTemplates();
    } else {
      this._appContextService.context.pipe(take(1)).subscribe(ctx => {
        this.currentUserId = ctx?.currentlyLoggedInUser?.id || '';
        this.loadTemplates();
      });
    }
  }

  loadTemplates(): void {
    this.isLoading = true;
    this._messageTemplatesService.getMessageTemplates(this.currentUserId).subscribe({
      next: (templates) => {
        this.templates = templates || [];
        this.isLoading = false;
      },
      error: () => {
        this.templates = [];
        this.isLoading = false;
      }
    });
  }

  get filteredTemplates(): MessageTemplate[] {
    if (!this.searchTerm?.trim()) return this.templates;
    const q = this.searchTerm.toLowerCase();
    return this.templates.filter(t =>
      (t.title || '').toLowerCase().includes(q) ||
      (t.response_message || '').toLowerCase().includes(q)
    );
  }

  get paginatedTemplates(): MessageTemplate[] {
    const list = this.filteredTemplates;
    const start = (this.currentPage - 1) * this.pageSize;
    return list.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredTemplates.length / this.pageSize) || 1;
  }

  isTemplateAuthor(template: MessageTemplate): boolean {
    const authorId = template.userId || template.createdByUserId;
    return !!authorId && authorId === this.currentUserId;
  }

  onUseTemplate(template: MessageTemplate, event: Event): void {
    event.stopPropagation();
    this.useTemplate.emit(template);
    this.bsModalRef.hide();
  }

  onEditTemplate(template: MessageTemplate, event: Event): void {
    event.stopPropagation();
    const initialState = {
      template,
      isEditMode: true
    };
    const options: ModalOptions = {
      initialState,
      class: 'modal-md modal-dialog-centered',
      ignoreBackdropClick: false
    };
    const ref = this._modalService.show(MessageTemplateModalComponent, options);
    ref.onHidden?.subscribe(() => {
      this.loadTemplates();
    });
  }

  onDeleteTemplate(template: MessageTemplate, event: Event): void {
    event.stopPropagation();
    if (!template.id) return;
    Swal.fire({
      title: 'Delete Template?',
      text: 'This template will be permanently deleted. Proceed?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#513DCA',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this._messageTemplatesService.deleteMessageTemplate(template.id!).subscribe({
          next: () => {
this.templates = this.templates.filter(t => t.id !== template.id);
          },
          error: (err) => {
}
        });
      }
    });
  }

  goToPage(page: number): void {
    this.currentPage = Math.max(1, Math.min(page, this.totalPages));
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
